import React, { useEffect, useState } from 'react'; 
import { Modal, ModalHeader, ModalBody,ModalFooter ,Button, Table, Tooltip , Spinner} from 'reactstrap';
import axios from 'axios';
import { BACKEND_URL_LOG } from "../../config/const.js";
import { useTranslation } from 'react-i18next';
import './style.css';

const LogDetails = ({ logId, openLogDetails, onCloseLogDetails }) => {
  
    const [log, setLog] = useState({});
    const [registreSections, setRegistreSections] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();
  
    useEffect(() => {
      
      if (logId) {
       
        fetchLogDetails();
      }
    }, [logId]);

    const fetchLogDetails = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL_LOG}getLogsById/${logId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        
        setLog(response);
        setRegistreSections(response.registre.sections);
      } catch (error) {
        console.error('Error fetching log details', error);
      } finally {
        setLoading(false); // Désactiver le loading une fois la requête terminée
      }
    };

  const getDetailValue = (key) => {
    return log.details[key];
  };

  const renderTableHeader = (type, title0, title1, title2) => {
    var typeAct =
    type &&
    type != "agentAndAction"
           ? type
           : "agent";
    switch (typeAct) {
      case "simple":
      case "simple2":
        return (
          <thead >
            <tr className="table-primary">
              <th style={{width:'33%'}} />
              <th style={{width:'33%'}}>{t(title1)}</th>
              <th style={{width:'33%'}}>{t(title2)}</th>
            </tr>
          </thead>
        );
        case "complex":
                            return ( 
                              <thead>
                              <tr className="table-primary">
                                <th style={{width:'2%'}} />
                                <th style={{width:'47%'}}>{t(title1)}</th>
                                <th style={{width:'47%'}}>{t(title2)}</th>
                              </tr>
                            </thead>
                            )
      case "checkbox":
      case "checkOther":
        if (log.registre.frequence === "eventDone") {
          return (
            <thead >
             <tr className="table-primary">
               <th style={{width:'2%'}}/>
              <th style={{width:'49%'}}/>
              <th style={{width:'49%'}}>{t(title2)}</th>
                 
               </tr>
          </thead>
          )
        }
        else {
          return ( 
            <thead >
           <tr className="table-primary">
               <th style={{width:'33%'}}/>
             
             <th style={{width:'33%'}}>{t(title1)}</th>
             <th style={{width:'33%'}}>{t(title2)}</th>
               </tr>
          </thead>
          )
        }
      case "temperature":
      case "tempNoAlert":
        return (
          <thead>
            <tr className="table-primary">
              <th style={{width:'2%'}}/>
              <th style={{width:'30%'}}>{t(title0)}</th>
              <th style={{width:'30%'}}>{t(title1)}</th>
              <th style={{width:'30%'}}>{t(title2)}</th>
            </tr>
          </thead>
        );
      default:
        return (
          <thead>
            <tr className="table-primary">
              <th tyle={{width:'2%'}}/>
              <th style={{width:'30%'}}>{t(title0)}</th>
              <th style={{width:'30%'}}>{t(title1)}</th>
              <th style={{width:'30%'}}>{t(title2)}</th>
            </tr>
          </thead>
        );
    }
  };

  const renderTableBody = (section, index) => {
    if(section){
      return section.activites.map((activite, i) => {
        const key = `${index}-${i}`;
        const keyAlert = `${index}-${i}-alert`;
        const check = activite.descr.split("\n");
  
        switch (activite.type) {
          case "simple":
          case "simple2":
            return (
              <tr key={i} style={{color:"black"}}>
                <td>{i + 1}</td>
                <td dangerouslySetInnerHTML={{ __html: activite.agents }}></td>
                <td dangerouslySetInnerHTML={{ __html: getDetailValue(key) }} />
              </tr>
            );
            case "complex":
              return (
                <tr style={{color:"black"}}>
                  <td>{i + 1}</td>
                  
                  <td dangerouslySetInnerHTML={{ __html: activite.agents }} ></td>
                  <td dangerouslySetInnerHTML={{ __html: getDetailValue(key) }} />
                </tr>
              );
              break;  
          case "checkbox":
          case "checkOther":
            if (log.registre.frequence === "eventDone") {
              return (
                <tr key={i} style={{color:"black"}}>
                  <td>{i + 1}</td>
                  <td>
                    {check.map((el, j) => {
                      if (log.details[`${index}-${i}-${j}`] === "1") {
                        return (
                          <div key={j}>
                            <i class="fa fa-check-circle" style={{fontSize:"24px"}}></i>
                           
                            <div  dangerouslySetInnerHTML={{ __html: el }} ></div>;
                          </div>
                        );
                      }
                      return <div key={j} dangerouslySetInnerHTML={{ __html: el }} ></div>;
                    })}
                  </td>
                  {activite.type === "checkOther" && (
                    <div dangerouslySetInnerHTML={{ __html: getDetailValue(index + "-" + i + "-other") }} />
                  )}
                </tr>
              );
              } else {
                return (
                  <tr key={i} style={{color:"black"}}>
                    <td>{i + 1}</td>
                    <td dangerouslySetInnerHTML={{ __html: activite.agents }}></td>
                    <td>
                      {check.map((el, j) => {
                        if (log.details[`${index}-${i}-${j}`] === "1") {
                          return (
                            <div key={j} className="inline-container">
                              <i class="fa fa-check-circle" style={{fontSize:"24px"}}></i> - <div dangerouslySetInnerHTML={{ __html: el }} />
                            </div>
                          );
                        }
                    return (
                      <div key={j} className="inline-container">
                        - <div dangerouslySetInnerHTML={{ __html: el }} />
                      </div>
                    );
              })}
    </td>
  
                </tr>
              );
            }
          case "temperature":
          case "tempNoAlert":
            const hasAlert = true;
            const alertType = hasAlert ? "checkbox" : "hidden";
            const alertText = hasAlert ? "alert" : "";
  
            return (
              <tr key={i} style={{color:"black"}}>
                <td>{i + 1}</td>
                <td dangerouslySetInnerHTML={{ __html: activite.etape }}></td>
                <td dangerouslySetInnerHTML={{ __html: activite.agents }}></td>
                <td>
                  {log.details[keyAlert] === "1" ? (
                    <div>
                      {getDetailValue(key)}
                      
                        <i class="fa fa-exclamation-triangle" style={{fontSize:"24px",color:"red",marginLeft: "10%"}}></i>
                        
                    </div>
                  ) : (
                    getDetailValue(key)
                  )}
                </td>
              </tr>
            );
          default:
            return (
              <tr key={i} style={{color:"black"}}>
                <td>{i + 1}</td>
                <td dangerouslySetInnerHTML={{ __html: activite.etape }}></td>
                <td dangerouslySetInnerHTML={{ __html: activite.agents }}></td>
                <td dangerouslySetInnerHTML={{ __html: activite.descr }}></td>
              </tr>
            );
        }
      });
    }
    
  };

 

  return (
    <Modal isOpen={openLogDetails}  size="xl">
       {loading ? (
        // 🔹 Loader sur tout le modal
        <div className="modal-loading-container">
          <div className="text-center mt-5">
                      <Spinner
                     color="primary"
                     style={{
                       height: '3rem',
                       width: '3rem'
                     }}
                   >
                     Loading...
                      </Spinner>
                      <div className="text-center mt-2">
                    {t("loading...")}
                    </div>
                    </div>
          <p>{t('Loading...')}</p>
        </div>
      ) : (
        <>
      <ModalHeader className="detail-header" style={{ width: '100%' }}>
                      <div className="modal-header-content">
                          <span className="modal-title">{t('log')}: {log.registre.title}</span>
                          <Button className="cancel-btn" onClick={onCloseLogDetails}>
                              {t('CLOSE')}
                          </Button>
                      </div>
        </ModalHeader>
      <ModalBody> 
     
        <div className="log-container">
      {registreSections && registreSections.length > 0 ? (
              registreSections.map((section, index) => {
                let title0 = "", title1 = "", title2 = "";
                switch (section.activites[0]?.type) {
                  case "simple":
                  case "complex":
                    title2 = "description";
                    break;
                  case "simple2":
                    title1 = "zone";
                    title2 = "agentDesinfectant";
                    break;
                  case "checkbox":
                    title2 = "description";
                    if (log.registre.frequence === "eventDone") title2 = "effectue";
                    break;
                  case "checkOther":
                    if (log.registre.frequence == "eventDone") title2 = "effectue";
                    break;
                  case "temperature":
                  case "tempNoAlert":
                    title0 = "zone";
                    title1 = "cible";
                    title2 = "valeur";
                    break;
                  case "agentRecette":
                    title2 = "recipe";
                    break;
                  default:
                    title0 = "etape";
                    title1 = "agents";
                    title2 = "actions";
                    break;
                }

                
                return (
                  <div key={index}>
                    <h3 style={{ color: "black", marginTop: "1%", marginBottom: "2%" }}>
                      {String.fromCharCode((index % 26) + 97).toUpperCase()} -{" "}
                      {section.title.toUpperCase()}
                    </h3>
                    
                    <Table>
                      {renderTableHeader(section.activites[0]?.type, title0, title1, title2)}
                      <tbody>{renderTableBody(section, index)}</tbody>
                    </Table>
                  </div>
                );
              })
            ) : (
              <p>Aucune section disponible</p>
            )}

    
   
        </div>
        <div className='divDetail'>{t('employee')}: <h3 className='divDetail'>{log.employe}</h3></div>
      <div className='divDetail'>{t('dateOfActivity')}: {log.dateOfActivity}</div>
      {log.registre.frequence != "eventResolution" && log.registre.frequence != "evenementiel"&&
                      
                    (  <div className='divDetail'>
                      {t('status')} : {t(log.status)}
                      </div>)
                      }
                    
      <div className='divDetail'>{t('note')}:</div>
      <div className='divDetail' dangerouslySetInnerHTML={{ __html: log.note }} />
      {/*  <Button color="primary" onClick={onCloseLogDetails}>{t('Close')}</Button> */}
      </ModalBody>
      </>
      )}
    </Modal>
  );
};

export default LogDetails;
